// components/SectionHeading.jsx
import React from 'react';
import { Typography } from '@mui/material';

export const SectionHeading = ({
    children,
    variant = 'h2',
    component = 'h2',
    mt = 4,
    sx = {},
    ...props
}) => (
    <Typography
        mt={mt}
        variant={variant}
        component={component}
        textAlign="center"
        gutterBottom
        sx={{
            background: 'linear-gradient(45deg, #4a90e2 0%, #9013fe 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold',
            my: 2, // 16px top & bottom by default
            fontSize: {
                xs: '1.5rem',  // ~24px on phones
                sm: '2.5rem',  // ~40px on tablets+
            },
            ...sx,
        }}
        {...props}
    >
        {children}
    </Typography>
);
